module.exports = __webpack_public_path__ + "img/icon-pay-success.05b15b6c.png";